import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PlatformItemsTab from './components/PlatformItemsTab';
import FinanceSectionPage from './components/FinanceSectionPage';
import { useUserStore } from '../../store/useUserStore';
import { FINANCE } from '../../common/constants/routes.constants';

/**
 * The catalogue every kindergarten inherits. Super admin only, and tied to no kindergarten,
 * so it skips the picker and the per-kindergarten invoicing gate.
 *
 * Anyone else is sent to the Finance overview rather than shown a page whose every request
 * would 403. The sidebar does not offer it to them in the first place.
 */
const FinancePlatformItemsPage: React.FC = () => {
  const { t } = useTranslation();
  const userInfo = useUserStore(state => state.userInfo);

  // wait for the user before deciding: a reload would otherwise bounce a super admin
  if (userInfo && !userInfo.isSuperAdmin) return <Navigate to={FINANCE} replace />;

  return (
    <FinanceSectionPage
      title={t('nav.financeItems.platformItems')}
      description={t('finance.pages.platformItemsDescription')}
      withoutKindergarten
    >
      {() => <PlatformItemsTab />}
    </FinanceSectionPage>
  );
};

export default FinancePlatformItemsPage;
